import { environment } from '@env/environment';
const license = environment.MITEK_LICENSE_KEY;

export const MitekConfig = {
  mode: '',
  documentType: '',
  mitekSDKPath: '../../assets/mitekSDK-5.6.0/mitekSDK/',
  options: {
    qualityPercent: 80,
    hintFrequencyMS: 2400,
    hintAriaLive: 0,
    faceDetectionLevel: 1,
    hintMessageSize: 1,
    license: license
  }
};
